import { useState, useEffect } from 'react';
import { AssetDropDown } from '../../UiComponents/AssetDropDown';
import { useParams } from 'react-router-dom';
import { YearDropDown } from '../../UiComponents/YearDropDown';
import { useNavigate } from 'react-router-dom';
import { BreadCrumbs } from '../../shared/breadCrumbs/BreadCrumbs';
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { getFinancialStatementAction, getFSDocumentAction, GetFinancialInvestmentsDropdownAction } from '../../actions/assetFinancialStatement';
import { getAsset } from '../../actions/assetAction';
import { getAssestListddlAction } from '../../actions/assetsddlAction';
import { useDispatch, useSelector } from 'react-redux';
import { FinancialStatementtab } from './FinancialStatementTabs';
import { UrlPath } from '../../../config/routeConfig';
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer, toast } from 'react-toastify';
import { sbaAxios } from '../../utils/sbaAxios';
import { InsertFinacialsummary, InsertFinancialInvestmentTotal, InsertAnalystReviewed, DownloadDocument } from '../../../config/apiConfig';
import { getFinancialStatementUrl } from "../../../config/apiConfig";
import './FinancialStatement.css';
import { AgGridReact } from 'ag-grid-react';
import { Modal } from 'react-bootstrap';
import { SBAEditor } from '../../UiComponents/SBAEditor';
import { Label } from '@progress/kendo-react-labels';
import { EditorUtils } from "@progress/kendo-react-editor"
import { SBADropDown } from '../../UiComponents/SBADropDown';
import { SBNotify } from "../../utils/sbNotify";
//import { Editor } from '@progress/kendo-react-editor';
const LastTenYearsDecemeberArray = () => {
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const now = new Date();
    const currentYear = now.getFullYear() - 1;
    const tenYearsAgo = currentYear - 10;
    const lastTenDecembers = [];
    for (let year = currentYear; year >= tenYearsAgo; year--) {
      let decemberLast = new Date(year, 12, 0);
      let decemberLastText = `${monthNames[decemberLast.getMonth()]} ${decemberLast.getDate()}, ${decemberLast.getFullYear()}`
      let output = { dateText: decemberLastText, dateObject: decemberLast , year:decemberLast.getFullYear()}
      lastTenDecembers.push(output);
    }
  
    return lastTenDecembers;
  }
export const FinancialStatement = () => {

    const Gstate = useSelector((state) => { return state }) || {};
    //    const AttachmentConfig=useSelector(state=>state.emailRules.AttachmentSecurity) || [];
    const isEditable = Gstate.authorizationData.isEditable;
    const financial = Gstate?.financialDetails?.financialStatement || {};
    const fsLoading = Gstate?.financialDetails?.isLoading;
    const AssetListDDL = Gstate.assetDDL.assetList || [];
    const currentAsset = Gstate.asset.asset || {};
    const AssetList = Gstate.assetDDL.assetList || [];
    const Documents = Gstate?.fsDocuments?.fsDocuments || [];
    const params = useParams();
    const history = useNavigate();
    const dispatch = useDispatch();
    const [Loading, setLoading] = useState(true);
    const currentDate = new Date();
    const previousYear = currentDate.getFullYear() - 1;
    const [taxYear, settaxYear] = useState(previousYear);
    const [render, setRender] = useState(true);
    const [saveDisabled, setSetDisaabled] = useState(false);
    const [saveResults, setSaveResults] = useState(false);
    const [tabData, setTabData] = useState({
        FinancialDetails: financial.FinancialDetails || [],
        FinancialInvestmentDetail: financial.FinancialInvestmentDetail || [],
        FinancialStatementsTypesTotals: financial.FinancialStatementsTypesTotals || [],
        ...financial
    });
    const [saveData, setSaveData] = useState();
    const [activeTab, setActiveTab] = useState(1);
    const [showDocument, setshowDocument] = useState(false);
    const [showReview, setshowReview] = useState(false);
    const [comments, setcomments] = useState();
    const [isOperationApproved, setisOperationApproved] = useState(false);
    const LastTenYearsDecemeber = LastTenYearsDecemeberArray();
    const [selectedYear,SetSelectedYear]=useState();

    useEffect(()=>{
        document.title = "Financial Statement";
        SetSelectedYear(LastTenYearsDecemeber[0])
     
     
    },[]);

    useEffect(() => {
    DispatchToStore();  
    }, [render]);

    const DispatchToStore = async () => {
        dispatch(getAssestListddlAction());
        dispatch(getAsset(params.Asset));
        dispatch(getFinancialStatementAction(params.Asset, taxYear));
        dispatch(GetFinancialInvestmentsDropdownAction());
    }

    useEffect(() => {
        (currentAsset && financial && AssetList && AssetListDDL) && setLoading(false);
    }, [Gstate]);

    useEffect(() => {
        setTabData(() => {
            return {
                FinancialDetails: financial.FinancialDetails || [],
                FinancialInvestmentDetail: financial.FinancialInvestmentDetail || [],
                FinancialStatementsTypesTotals: financial.FinancialStatementsTypesTotals || [],
                ...financial
            }
        }
        )
         setSaveData(() => {
             return {
                 FinancialDetails: financial.FinancialDetails || [],
                 FinancialInvestmentDetail: financial.FinancialInvestmentDetail || [],
                 FinancialStatementsTypesTotals: financial.FinancialStatementsTypesTotals || [],
                 ...financial
             }
         }
         )

    }, [financial])
    
    const YearDropDownChanged = (e) => {
        SetSelectedYear(e.value)
        settaxYear(() => e.value.dateObject.getFullYear());
        setRender(!render);
        sbaAxios({
            url: `${getFinancialStatementUrl}${params.Asset},${e.value.dateObject.getFullYear()}`,
            method: 'get',
        }).then((response) => {

            setTabData(() => {
                return {
                    FinancialDetails: response.FinancialDetails || [],
                    FinancialInvestmentDetail: response.FinancialInvestmentDetail || [],
                    FinancialStatementsTypesTotals: response.FinancialStatementsTypesTotals || []
                 
                }
            })
            setSaveData(() => {
                return {
                    FinancialDetails: response.FinancialDetails || [],
                    FinancialInvestmentDetail: response.FinancialInvestmentDetail || [],
                    FinancialStatementsTypesTotals: response.FinancialStatementsTypesTotals || []
                }
            })
        }).catch();
    };
    const AssetDropDownChanged = (e) => {
        e.value ? history(`${UrlPath.AssetFinancialStatement}${e.value.AssetId}`) : history(`${UrlPath.AssetFinancialStatement}${params.Asset}`);
        setRender(!render);
        sbaAxios({
            url: `${getFinancialStatementUrl}${e.value.AssetId},${taxYear}}`,
            method: 'get',
        }).then((response) => {
            setTabData(() => {
                return {
                    FinancialDetails: response.FinancialDetails || [],
                    FinancialInvestmentDetail: response.FinancialInvestmentDetail || [],
                    FinancialStatementsTypesTotals: response.FinancialStatementsTypesTotals || [],
                }
            })
            setSaveData(() => {
                return {
                    FinancialDetails: response.FinancialDetails || [],
                    FinancialInvestmentDetail: response.FinancialInvestmentDetail || [],
                    FinancialStatementsTypesTotals: response.FinancialStatementsTypesTotals || [],
                }
            })
        }).catch();
    };
   

    const DispatchSaveEvent = () => {
        let saveSuccess = true;
        const TotalInvestmentSecurities = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 9)[0] || {};
        const TotalInvestmentSecuritiesTotal = parseFloat(TotalInvestmentSecurities?.FinancialStatementTypeTotal || 0);
        const TotalDerivativeContracts = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 10)[0] || {};
        const TotalDerivativeContractsTotal = parseFloat(TotalDerivativeContracts?.FinancialStatementTypeTotal || 0);
        const TotalSecuritiesSold = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 11)[0] || {};
        const TotalSecuritiesSoldTotal = parseFloat(TotalSecuritiesSold?.FinancialStatementTypeTotal || 0);
        const isverifi =false;
        const financialInvestments = saveData.FinancialInvestmentDetail.map(item => ({
            "securityId": item.SecurityId,
            "financialStatementTypeId": item.FinancialStatementTypeId,
            "investmentValue": item.InvestmentValue,            
            "isVerified": (item.IsVerified === null) ? isverifi:item.IsVerified
        })) || [];
        const financialInvestmentData = {
            "financialStatementSummaryId": saveData.FinancialStatementSummaryId,
            "assetId": saveData.AssetId,
            "finYear": saveData.FinYear===0?selectedYear.year:saveData.FinYear,
            "totalInvestmentSecurities": TotalInvestmentSecuritiesTotal,
            "totalDerivativeContracts": TotalDerivativeContractsTotal,
            "totalSecuritiesSold": TotalSecuritiesSoldTotal,
            "financialInvestments": financialInvestments,          
            "createdby": 32,
        };

        const totalInvIncome = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 3)[0]?.FinancialStatementTypeTotal || 0;
        const totalExpenses = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 4)[0]?.FinancialStatementTypeTotal || 0;
        const totalLiability = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 2)[0]?.FinancialStatementTypeTotal || 0;
        const totalLeveAsset = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 12)[0]?.FinancialStatementTypeTotal || 0;
        const totalLevelLiability = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 13)[0]?.FinancialStatementTypeTotal || 0;
        const totalAsset = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 1)[0]?.FinancialStatementTypeTotal || 0;
        const netAsset = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 8)[0]?.FinancialStatementTypeTotal || 0;
        const totalRetAfterIncentive = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 14)[0]?.FinancialStatementTypeTotal || 0;
        const totalExpenAfterIncentive = saveData.FinancialStatementsTypesTotals.filter(item => item.FinancialStatementTypeId === 15)[0]?.FinancialStatementTypeTotal || 0;
        const financialStatementValues = saveData.FinancialDetails.map(item => (
            item.FinancialStatementName !== "Net increase/(decrease) of net assets" 
            ? {
                "financialStatementId": item.FinancialStatementId,
                "value": item.Value,
                "isVerified": item.IsVerified
              }
            : null
        )) || [];
        const financialStatementSummary = {
            "financialStatementSummaryId": saveData.FinancialStatementSummaryId,
            "assetId": parseInt( params.Asset),
            "finYear": saveData.FinYear===0?selectedYear.year:saveData.FinYear,
            "asset":totalAsset,
            "liability": totalLiability,
            "netAssets": saveData.NetAssets,
            "totalInvIncome": totalInvIncome,
            "totalExpenses": totalExpenses,
            "netInvestIncome": saveData.NetInvestIncome,
            "netGainInvestIncome": saveData.NetGainInvestIncome,
            "netIncreaseAsset": saveData.NetIncreaseAsset,
            "netIncreaseDecreaseAsset": saveData.NetIncreaseDecreaseAsset,
            "netAssetEOY":saveData.NetAssetEOY,
            "createdby": 32,
            "totalLevelAssets": totalLeveAsset,
            "totalLevelLiability": totalLevelLiability,
            "totalReturnAfterIncentiveFee": totalRetAfterIncentive,
            "totalExpensesAfterIncentiveFee": totalExpenAfterIncentive,
            "financialStatementValues": financialStatementValues,
            "auditor": saveData.AuditorId,
            "opinion": saveData.OpinionId,
            "issueDate": saveData.IssueDate,
            "masterFeeder": saveData.IsMasterFeeder,
            "currencyId": saveData.CurrencyId,
            "issuingOfficeId": saveData.IssuingOfficeId,
            "accountingStandardType": saveData.AccountingStandardId,
            "cftc": saveData.IsCFTC,
            "ownershipInMF": saveData.OwnershipInMF
        };

        if (activeTab == 1 || activeTab == 3) {
           
            if (saveData.AuditorId === -1 || saveData.AuditorId === 0) {
                SBNotify({ Msg: "Please Select Auditor", type: "error" });
                saveSuccess = false;
                return;
            }
           else if (saveData.IssuingOfficeId === -1 || saveData.IssuingOfficeId === 0) {
                SBNotify({ Msg: "Please Select Issuing Office", type: "error" });
                saveSuccess = false;
                return;
            }
           else if (saveData.AccountingStandardId === 0 || saveData.AccountingStandardId === 0) {
                SBNotify({ Msg: "Please Select Accounting Standard", type: "error" });
                saveSuccess = false;
                return;
            }
            else if (saveData.AccountingStandardId === 0) {
                SBNotify({ Msg: "Please Select Accounting Standard", type: "error" });
                saveSuccess = false;
                return;
            }
            else if (saveData.CurrencyId === -1) {
                SBNotify({ Msg: "Please Select Currency", type: "error" });
                saveSuccess = false;
                return;
            }
            else if (!saveData.IssueDate) {
                SBNotify({ Msg: "Please Select Issue Date", type: "error" });
                saveSuccess = false;
                return;
            }
            if (saveSuccess) {
                setLoading(true);
            sbaAxios({
                url: `${InsertFinacialsummary}`,
                method: 'post',
                data: financialStatementSummary,
            })
                .then(() => {
                    toast.success("Financial Statement Updated Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    setLoading(false);
                    setRender(!render);
                    dispatch(getFinancialStatementAction(params.Asset, taxYear));
                
                }).catch(() => {
                    toast.error("Error saving Data -Financial summary", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    setRender(!render);
                });
        }
    }
        else if (activeTab == 2) {
            setLoading(true);

            sbaAxios({
                url: `${InsertFinancialInvestmentTotal}`,
                method: 'post',
                data: financialInvestmentData,
            })
                .then(() => {
                    toast.success("Financial Investment Updated Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    setLoading(false);
                    setRender(!render);
                    dispatch(getFinancialStatementAction(params.Asset, taxYear));
                }).catch(() => {
                    toast.error("Error saving Data -Investment Tab Data", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setRender(!render);

                });
        }
        setTabData(saveData);
    }

    const DispatchReloadEvent = () => {
        const reloadEvent = new CustomEvent("custom:reload")
        document.dispatchEvent(reloadEvent);
    }
    const ViewDocuments = () => {
        setshowDocument(true);
      
        dispatch(getFSDocumentAction(params.Asset, 1, 7,1));
    }
    const closedocumentmodal = () => {
        setshowDocument(false);
    }
    const pdfview = (params) => {
        try {
            const documentId = params.data.DocumentId
            const documentName = params.data.DocumentName;
            const encodedDocumentId = btoa(documentId.toString());
            const urls = DownloadDocument + encodedDocumentId;
            sbaAxios({
                url: urls,
            }).then((response) => {
                window.open(urls);
            });
        } catch (error) {
            console.error("Error opening document:", error);
        }
    }
    const columnDefs = [
        { field: "DocumentName", headerName: "File Name", width: "430%", sort: 'asc', filter: 'agTextColumnFilter' },
        {
            headerName: '',
            field: 'DocumentId',
            width: "10%",
            cellRenderer: (params) => {
                return <i class="far fa-file-pdf SBA_hand" style={{ color: "red" }} onClick={() => pdfview(params)}  ></i>;
            },
        },
    ];
    const OpenReviewpopup = () => {

        setshowReview(true);
 
        const txtComment = saveData?.Comments;
        const textWithoutPTags = txtComment.replace(/<p>|<\/p>/g, '');
        setcomments(txtComment);
        setisOperationApproved(saveData?.IsOperationsApproved)
    }
    const closeReviewpopup = () => {
        setshowReview(false);
    }
    const commentsChange = (event) => {
        // const val=event.html;
        // const comment=val.replace(/<p[^>]*>(.*?)<\/p>/g, '$1');
        // setcomments(comment);
        setcomments(event.html);
    }

    const SaveComments = () => {
        let saveSuccess = true;
        let errorMsg = [];
        const data = {
            "financialStatementSummaryId": saveData.FinancialStatementSummaryId,
            "assetId": saveData.AssetId,
            "finYear": saveData.FinYear,
            "comments": comments,
            "isOperationsApproved": isOperationApproved,
            "invAnalysisUserId": 0
        }
        if (saveSuccess) {
            sbaAxios({
                url: `${InsertAnalystReviewed}`,
                method: 'post',
                data: data,
            })
                .then((response) => {
                    setshowReview(false);
                    toast.success("Comments Saved Successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    })
                    dispatch(getFinancialStatementAction(params.Asset, taxYear));
                })

                .catch((error) => {
                    console.error(error);
                });
        }



        else {
            let ErrorString = "";
            errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
            console.log(errorMsg);
            toast.error(ErrorString, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }

    }
    let Level = [{ BreadCrumb: "Asset > ", Routes: `${UrlPath.Asset}` }];
    Level = Loading ? Level : [...Level, { BreadCrumb: `${currentAsset.AssetName} > `, Routes: `${UrlPath.AssetDetails}${params.Asset}` }, { BreadCrumb: `FinancialStatement `, Routes: `${UrlPath.AssetFinancialStatement}${params.Asset}` }];

    return (
        <>{Loading ? <><LoadingScreen /></> : <> <TopBar label={"Financial Statements"} />
            <div className='MainContent financialStatement mainContentData'>
                <BreadCrumbs Levels={Level} />
                <div className='container-fluid TaxPage'>
                    <div className='SubTopbar'>
                        <div className='SubTopbarLabel'><label>Asset :</label></div>
                        <div className='DropDownDiv' style={{ width: "600px" }}><AssetDropDown value={currentAsset} onChange={AssetDropDownChanged} data={AssetListDDL} /></div>
                        <div className='SubTopbarLabel'><label>Year :</label></div>
                        <div className='DropDownDiv' style={{ width: "225px" }} >
                            <SBADropDown data={LastTenYearsDecemeber} value={selectedYear} onChange={YearDropDownChanged} textField='dateText' valueField='year' />
                            </div>
                        <div className="col-md-4 d-flex align-items-lg-end"  >
                            <button type="submit" className='p-sm-btn mx-1' disabled={saveDisabled || !isEditable} onClick={DispatchSaveEvent}> Save</button>
                            <button className="p-sm-btn mx-1" onClick={DispatchReloadEvent}> <i className="fa-solid fa-rotate-right" /> Reload</button>
                            <button type="submit" className='p-sm-btn mx-1' onClick={OpenReviewpopup}>Review</button>
                        </div>
                        <div>
                        </div>
                    </div>
                    <div className='container-fluid'>
                    </div>
                    <div className='container-fluid Tabscontainer'>                                                 
                        <a><i class="fa-solid fa-file" style={{ color: "#337ab7 !important;cursor:pointer;", float: "right" }} title="Show Preview" onClick={ViewDocuments}></i></a> 
                        {fsLoading ? <><LoadingScreen/></>: <>                        
                         <FinancialStatementtab tabData={tabData} setTabData={setSaveData} setActiveTab={setActiveTab} activeTab={activeTab} AssetId={params.Asset} AssetYear={taxYear}  saveData={saveData}/></>}
                    </div>
                </div>
            </div>
        </>}
            <Modal show={showDocument} >
                <Modal.Header closeButton onClick={closedocumentmodal}>
                    <Modal.Title>View Documents</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="ag-theme-alpine" style={{ width: '100%' }}>

                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={Documents}
                            defaultColDef={{resizable:true}}
                        //   pagination={true}
                        //   paginationPageSize={20}
                        //   sideBar={sideBar}
                        //   enableBrowserTooltips={true}
                        >

                        </AgGridReact>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={closedocumentmodal} > Cancel</button>
                </Modal.Footer>
            </Modal>

            <Modal className='modal-lg' show={showReview} >
                <Modal.Header closeButton onClick={closeReviewpopup}>
                    <Modal.Title>Add/View Comments</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Label className='fw-Bold'>Comments</Label>
                        <label style={{ display: 'flex', alignItems: 'center', marginTop: "20px" }}>
                            <input className="me-1"
                                type="checkbox"
                                defaultChecked={isOperationApproved}
                                onChange={() => {
                                    setisOperationApproved(value => !value)
                                }}
                            />
                            <span > Operation Approved</span>
                        </label>
                        <div>
                        </div>
                    </div>
                    <SBAEditor id="editor" onChange={commentsChange} defaultContent={comments} editorHeight={300} setContent={setcomments}></SBAEditor>
                    {/* <textarea className="form-control" rows={7} defaultValue={comments} onChange={commentsChange} ></textarea> */}
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={closeReviewpopup} > Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={SaveComments}>Save</button>
                </Modal.Footer>
            </Modal>
            <ToastContainer />
        </>
    )
}
